'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChatEmoticonGroupItem, ChatEmoticonItem } from '@module/apis/client-side/chat-emoticon/type';
import type { Theme } from '@module/global';
import { cn } from '@module/lib/utils';
import { useGetChatEmoticonGroupQuery, useGetChatEmoticonQuery } from '@module/queries/chat-emoticon/chatEmoticonQueryHooks';
import useChatPanelStore from '@module/stores/useChatPanelStore';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import CloseMdIcon from '../icons/components/CloseMd';
import BaseSpinner from '../Spinner/BaseSpinner';
interface ChatEmoticonSelectBoxViewProps {
  onClose?: () => void; // mobile은 닫기 버튼 없음
  className?: string;
  style?: React.CSSProperties;
  groups: ChatEmoticonGroupItem[];
  emoticons: ChatEmoticonItem[];
  selectedGroup: ChatEmoticonGroupItem | null;
  onSelectGroup: (group: ChatEmoticonGroupItem) => void;
  onSelectEmoticon: (item: ChatEmoticonItem) => void;
  isLoading: boolean;
  theme?: Theme;
  deviceOrientation?: 'portrait' | 'landscape';
}

// 스토리북 등록을 위해 view component를 분리함
export function ChatEmoticonSelectBoxView(t0) {
  const $ = _c(31);
  const {
    onClose,
    className,
    style,
    groups,
    emoticons,
    selectedGroup,
    onSelectGroup,
    onSelectEmoticon,
    isLoading,
    theme,
    deviceOrientation: t1
  } = t0;
  const deviceOrientation = t1 === undefined ? "portrait" : t1;
  const selectedBlockEmoticon = useChatPanelStore(_temp);
  let t2;
  if ($[0] !== className) {
    t2 = cn("h-[400px]", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = theme === "dark";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("flex h-[64px] items-center justify-between gap-1 border-t border-t-system-level3 bg-system-white px-5 py-3", {
      "bg-[#111111]": t3
    });
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== groups || $[5] !== onSelectGroup || $[6] !== selectedGroup?.name) {
    let t6;
    if ($[8] !== onSelectGroup || $[9] !== selectedGroup?.name) {
      t6 = item => <button type="button" key={item.name} className={cn("h-10 w-10 shrink-0 rounded-[6px] p-1", {
        "bg-system-level4": selectedGroup?.name === item.name
      })} onClick={() => onSelectGroup(item)}><Image src={item.img} alt={item.name} width={32} height={32} /></button>;
      $[8] = onSelectGroup;
      $[9] = selectedGroup?.name;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = groups.map(t6);
    $[4] = groups;
    $[5] = onSelectGroup;
    $[6] = selectedGroup?.name;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <div className="scrollbar-hide flex h-10 w-full items-center gap-2 overflow-x-auto">{t5}</div>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onClose) {
    t7 = onClose && <button onClick={onClose} className="flex h-10 w-6 shrink-0 items-center justify-end"><CloseMdIcon className="text-system-level1" width={24} height={24} /></button>;
    $[13] = onClose;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
    t8 = <div className={t4}>{t6}{t7}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== deviceOrientation || $[20] !== emoticons || $[21] !== isLoading || $[22] !== onSelectEmoticon || $[23] !== selectedBlockEmoticon) {
    t9 = <div className="scrollbar-custom h-[calc(100%-64px)] overflow-y-auto bg-system-level4 px-5 py-6">{isLoading ? <BaseSpinner className="mx-auto" /> : <div className={cn("grid grid-cols-4 justify-items-center gap-y-4", {
        "grid-cols-8": deviceOrientation === "landscape"
      })}>{emoticons.map(item_0 => <button key={item_0.idx} type="button" className={cn("h-[60px] w-[60px]", {
          "opacity-20": !!selectedBlockEmoticon && emoticons.some(e => e.idx === selectedBlockEmoticon.idx) && selectedBlockEmoticon.idx !== item_0.idx
        })} onClick={() => onSelectEmoticon(item_0)}><Image src={item_0.img} alt={item_0.name} width={60} height={60} /></button>)}</div>}</div>;
    $[19] = deviceOrientation;
    $[20] = emoticons;
    $[21] = isLoading;
    $[22] = onSelectEmoticon;
    $[23] = selectedBlockEmoticon;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== style || $[26] !== t2 || $[27] !== t8 || $[28] !== t9 || $[29] !== theme) {
    t10 = <div className={t2} style={style} data-theme={theme}>{t8}{t9}</div>;
    $[25] = style;
    $[26] = t2;
    $[27] = t8;
    $[28] = t9;
    $[29] = theme;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
}
function _temp(state) {
  return state.selectedBlockEmoticon;
}
interface Props {
  onClose?: () => void; // mobile은 닫기 버튼 없음
  className?: string;
  style?: React.CSSProperties;
  userIdx: number;
  onSelect: (item: ChatEmoticonItem) => void;
  theme?: Theme;
  deviceOrientation?: 'portrait' | 'landscape';
}
function ChatEmoticonSelectBox(t0) {
  const $ = _c(27);
  const {
    onClose,
    className,
    style,
    userIdx,
    onSelect,
    theme,
    deviceOrientation
  } = t0;
  const [selectedGroup, setSelectedGroup] = useState(null);
  let t1;
  if ($[0] !== userIdx) {
    t1 = {
      userIdx
    };
    $[0] = userIdx;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!userIdx;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      enabled: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: chatEmoticonGroupData,
    isLoading: isChatEmoticonGroupLoading
  } = useGetChatEmoticonGroupQuery(t1, t3);
  const t4 = selectedGroup?.name;
  let t5;
  if ($[4] !== t4 || $[5] !== userIdx) {
    t5 = {
      group: t4,
      userIdx
    };
    $[4] = t4;
    $[5] = userIdx;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = !!userIdx;
  let t7;
  if ($[7] !== t6) {
    t7 = {
      enabled: t6
    };
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const {
    data: chatEmoticonData,
    isLoading: isChatEmoticonLoading
  } = useGetChatEmoticonQuery(t5, t7);
  let t8;
  let t9;
  if ($[9] !== chatEmoticonGroupData) {
    t8 = () => {
      if (chatEmoticonGroupData?.list.length) {
        setSelectedGroup(chatEmoticonGroupData.list[0]);
      }
    };
    t9 = [chatEmoticonGroupData];
    $[9] = chatEmoticonGroupData;
    $[10] = t8;
    $[11] = t9;
  } else {
    t8 = $[10];
    t9 = $[11];
  }
  useEffect(t8, t9);
  let t10;
  if ($[12] !== chatEmoticonGroupData?.list) {
    t10 = chatEmoticonGroupData?.list || [];
    $[12] = chatEmoticonGroupData?.list;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== chatEmoticonData?.list) {
    t11 = chatEmoticonData?.list || [];
    $[14] = chatEmoticonData?.list;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = isChatEmoticonLoading || isChatEmoticonGroupLoading;
  let t13;
  if ($[16] !== className || $[17] !== deviceOrientation || $[18] !== onClose || $[19] !== onSelect || $[20] !== selectedGroup || $[21] !== style || $[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== theme) {
    t13 = <ChatEmoticonSelectBoxView theme={theme} onClose={onClose} className={className} style={style} groups={t10} emoticons={t11} selectedGroup={selectedGroup} onSelectGroup={setSelectedGroup} onSelectEmoticon={onSelect} isLoading={t12} deviceOrientation={deviceOrientation} />;
    $[16] = className;
    $[17] = deviceOrientation;
    $[18] = onClose;
    $[19] = onSelect;
    $[20] = selectedGroup;
    $[21] = style;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = theme;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
}
export default ChatEmoticonSelectBox;